import { useSwiper } from "swiper/react";

export const SwiperNavButtons = ({
  padding,
  hideOnMobile,
  isBeginning,
  isEnd,
}) => {
  const swiper = useSwiper();

  let paddingLeft = null;
  let paddingRight = null;

  switch (padding) {
    case "large":
      paddingLeft = "xl:left-56";
      paddingRight = "xl:right-56";
      break;

    default:
      paddingLeft = "left-5 lg:left-36 xl:left-96";
      paddingRight = "right-5 lg:right-36 xl:right-96";
      break;
  }

  return (
    <div className={`swiper-navigation`}>
      <button
        className={`prev-button absolute transition-opacity ${paddingLeft} top-1/2 -translate-y-1/2 z-20 swiper-button ${
          isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
        onClick={() => swiper.slidePrev()}
        aria-label="Előző slide"
      >
        <img
          src="/arrow-left.svg"
          alt="Előző slide"
          className="w-14 relative"
          width="48"
          height="22"
          loading="lazy"
        />
      </button>
      <button
        className={`next-button absolute transition-opacity ${paddingRight} top-1/2 -translate-y-1/2 z-20 swiper-button ${
          isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
        onClick={() => swiper.slideNext()}
        aria-label="Következő slide"
      >
        <img
          src="/arrow-right.svg"
          alt="Következő slide"
          className="w-14 relative"
          width="48"
          height="22"
          loading="lazy"
        />
      </button>
    </div>
  );
};
